import React from 'react';

const SkipLink = () => {
    const skipToMain = (e) => {
        e.preventDefault();
        const main = document.querySelector('main');
        if (main) {
            main.setAttribute('tabindex', '-1');
            main.focus();
            main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <a
            href="#main-content"
            onClick={skipToMain}
            className="skip-link fixed top-2 left-2 z-[200] bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wider opacity-0 -translate-y-full focus:opacity-100 focus:translate-y-0 transition-all duration-200"
        >
            Saltar al contenido principal
        </a>
    );
};

export default SkipLink;
